<!--  -->
<template>
  <div :class="['tempAdress', { inApp: $root.$data.isApp || this.$root.miniprogram }]">
    <common-title
      titleName="收货地址"
      :zIndex="1000"
      :bcColor="'#F7F8FC'"
      @goBack="goBack"
    ></common-title>
    <div class="tempAdress-body">
      <van-form ref="formData"  @submit="onSubmit">
        <div class="content">
          <van-field
            class="first-field"
            v-model.trim="ruleForm.consignee"
            name="name"
            label="收件人"
            placeholder="收件人"
          />
          <van-field
            v-model.trim="ruleForm.phone"
            type="tel"
            name="phone"
            label="手机号"
            placeholder="手机号"
          />
          <van-field
            readonly
            :value="ruleForm.local"
            right-icon="arrow"
            name="local"
            label="所在地区"
            placeholder="点击选择省市区"
            @click="showArea = true"
          />
          <van-popup v-model="showArea" position="bottom">
            <van-area :area-list="areaList" @confirm="onConfirm" @cancel="showArea = false" />
          </van-popup>
          <van-field
            class="four-field"
            v-model.trim="ruleForm.address"
            rows="1"
            autosize
            type="textarea"
            clearable
            name="address"
            label="详细地址"
            placeholder="详细地址"
          />
        </div>
        <div class="footer" :class="{ miniFooter: $root.$data.isApp || this.$root.miniprogram }">
          <van-button
            round
            block
            type="info"
            :loading="loading"
            loading-text="保存并使用"
            native-type="submit"
            >确定</van-button
          >
        </div>
      </van-form>
      <h2 class="adressTitle">注：地址填写后不能更改，奖品预计30个工作日内发货</h2>
    </div>
    <template> </template>
  </div>
</template>

<script>
import CommonTitle from '@/components/header/CommonTitle.vue';
import { reqAdddDressUrl } from '@/api/activity/index';

// eslint-disable-next-line import/extensions
import { areaList } from '@vant/area-data';

export default {
  data() {
    return {
      ruleForm: {
        consignee: '',
        phone: '',
        local: '',
        address: '',
        type: 0,
      },
      myAddressProvince: '',
      myAddressCity: '',
      myAddresscounty: '',
      areaList,
      showArea: false,
      isClickCopy: true, // 防止多次点击设定
      loading: false,
    };
  },

  components: {
    CommonTitle,
  },

  computed: {},
  watch: {},
  created() {
  },

  mounted() {
    document.title = '收货地址';
  },

  methods: {
    checkDefault(val) {
      this.ruleForm.type = val;
    },
    onSubmit() {
      this.submitForm();
    },
    save() {
      this.$refs.formData.onSubmit();
    },
    // 拆分地址省市区
    splitArea(data) {
      const array = data.split(' ');
      const a1 = array[0];
      const a2 = array[1];
      const a3 = array[2];
      this.myAddressProvince = a1;
      this.myAddressCity = a2;
      this.myAddresscounty = a3;
    },
    // 省市区选择器弹窗的确认
    onConfirm(values) {
      this.ruleForm.local = values
        .filter((item) => !!item)
        .map((item) => item.name)
        .join(' ');
      this.showArea = false;
    },
    // 校验信息
    async submitForm() {
      const { consignee, phone, local, address } = this.ruleForm;
      if (consignee === '') {
        this.$toast({
          message: '请输入收货人名称',
          position: 'middle',
          duration: 1000,
        });
      } else if (!/^[\u4e00-\u9fa50-9A-Za-z]{2,5}$/i.test(consignee)) {
        this.$toast({
          message: '收货人请输入2～5位字符，特殊字符除外!',
          position: 'middle',
          duration: 1000,
        });
      } else if (phone === '') {
        this.$toast({
          message: '请输入收货人手机号',
          position: 'middle',
          duration: 1000,
        });
      } else if (!/^1(3|4|5|6|7|8|9)\d{9}$/.test(phone)) {
        this.$toast({
          message: '请输入正确的手机号',
          position: 'middle',
          duration: 1000,
        });
      } else if (local === '') {
        this.$toast({
          message: '请选择城市信息',
          position: 'middle',
          duration: 1000,
        });
      } else if (address === '') {
        this.$toast({
          message: '请输入详细地址',
          position: 'middle',
          duration: 1000,
        });
      }else if (address.length >30) {
        this.$toast({
          message: '详细地址请输入1～30位字符',
          position: 'middle',
          duration: 1000,
        });
      } else {
        this.splitArea(local);
        // 二次确认弹窗
        this.modifyAddress();
      }
    },
    // 新增地址信息
    async getAddAddress() {
      if (this.isClickCopy) {
        this.isClickCopy = false;
        const { consignee, phone, address } = this.ruleForm;
        const addressInfo = {
          address,
          area: this.myAddresscounty,
          city: this.myAddressCity,
          phone,
          province: this.myAddressProvince,
          consignee
         
        };
        try {
          this.loading = true;
          const res = await reqAdddDressUrl(addressInfo);
          if (res.code === 0) {
            this.$toast('填写地址成功！');
            this.isClickCopy = true;
            this.loading = false;
            this.$router.go(-1);
          }
        } catch (error) {
          this.loading = false;
          this.isClickCopy = true;
          this.$toast(error.message);
        }
      }
    },
    // 二次确认弹窗
    modifyAddress(type, address) {
      this.$dialog
        .confirm({
          confirmButtonText: '确定',
          confirmButtonColor: '#FF6C02',
          message: '是否确认使用该收货地址',
        })
        .then(() => {
          this.getAddAddress();
        })
        .catch(() => {
          // on cancel
          this.isClickCopy = true;
        });
    },

    goBack() {
      if (this.$root.$data.isApp) {
        this.$sendToApp('closePage');
      } else {
        // 返回上一级
        this.$router.go(-1);
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.tempAdress {
  position: absolute;
  width: 100%;
  min-height: 100%;
  padding-top: 120px;
  color: $fontColorBlack;
  background: #f7f8fc;

  &.inApp {
    padding-top: 33px;
  }

  &-body {
    padding: 0 36px 36px;
    background: #f7f8fc;

    .adressTitle {
      margin-top: 40px;
      color: #787878;
      font-weight: 400;
      font-size: 25px;
      color: #ff3938;
      text-align: center;
    }

    ::v-deep .van-cell {
      &::after {
        border-bottom: none;
      }

      .van-field__label {
        span {
          color: $fontColorBlack;
          font-weight: 500;
          font-size: 14px;
          line-height: 20px;
        }
      }
    }

    .content {
      .first-field {
        padding-top: 43px;
        border-radius: 14px 14px 0 0;
      }

      .four-field {
        // border-radius: 0 0 14px 14px;
      }
    }

    .default {
      display: flex;
      align-items: center;
      box-sizing: border-box;
      width: 100%;
      height: 100px;
      padding: 0 36px;
      font-weight: 400;
      font-size: 25px;
      background-color: $bgWhite;
      border-radius: 0 0 14px 14px;

      .img-icon {
        width: 36px;
        height: 36px;
      }

      ::v-deep .van-radio__label {
        color: #787878;
      }

      // border-radius: 14px;
    }

    .footer {
      position: fixed;
      bottom: 26px;
      left: 50%;
      z-index: 11;
      width: 88%;
      transform: translate(-50%, 0);

      ::v-deep .van-button {
        &--block {
          height: 48px;
        }

        &--info {
          background-color: $theme_color;
          border: 1px solid $theme_color;
        }
      }

      ::v-deep .van-button__text {
        font-size: 18px;
        line-height: 25px;
      }

      .button {
        @include commonBtn(100%, 91px, $theme_color, 45px, 36px, $bgWhite);

        font-weight: normal;
      }
    }
    .miniFooter{
      ::v-deep .van-button {
        &--block {
          height: 40px;
        }
      }
    }
  }
}
</style>
